module.exports = __webpack_public_path__ + "2809232441116df0952f2ca82d159688.jpg";